import type { Benefit } from "../types/benefit";

const sampleBenefits: Benefit[] = [
  {
    categoria: "Desconto",
    nome: "20% Off na Farmácia X",
    descricao: "Economize em medicamentos e cuidados pessoais com desconto exclusivo para embaixadores.",
    link: "https://example.com/farmacia-x",
    imagem: "https://images.pexels.com/photos/356040/pexels-photo-356040.jpeg?auto=compress&cs=tinysrgb&w=800",
    destaque: "Sim",
  },
  {
    categoria: "Desconto",
    nome: "15% Off em Cursos Online",
    descricao: "Aprenda novas habilidades com desconto especial em plataformas de ensino.",
    link: "https://example.com/cursos",
    imagem: "https://images.pexels.com/photos/4144923/pexels-photo-4144923.jpeg?auto=compress&cs=tinysrgb&w=800",
    destaque: "Não",
  },
  {
    categoria: "Plano",
    nome: "Plano Saúde Premium",
    descricao: "Cobertura completa para você e sua família com condições especiais.",
    link: "https://example.com/saude-premium",
    imagem: "https://images.pexels.com/photos/4386466/pexels-photo-4386466.jpeg?auto=compress&cs=tinysrgb&w=800",
    destaque: "Sim",
  },
  {
    categoria: "Plano",
    nome: "Plano Odonto Light",
    descricao: "Tratamentos odontológicos com preço acessível e qualidade garantida.",
    link: "https://example.com/odonto-light",
    imagem: "https://images.pexels.com/photos/3845810/pexels-photo-3845810.jpeg?auto=compress&cs=tinysrgb&w=800",
    destaque: "Não",
  },
  {
    categoria: "Parceria",
    nome: "Academia SmartFit",
    descricao: "Treine em qualquer unidade com desconto exclusivo para embaixadores CRO Brasil.",
    link: "https://example.com/smartfit",
    imagem: "https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg?auto=compress&cs=tinysrgb&w=800",
    destaque: "Sim",
  },
  {
    categoria: "Parceria",
    nome: "Netflix 3 meses grátis",
    descricao: "Entretenimento sem custo adicional por 3 meses completos.",
    link: "https://example.com/netflix",
    imagem: "https://images.pexels.com/photos/4009402/pexels-photo-4009402.jpeg?auto=compress&cs=tinysrgb&w=800",
    destaque: "Não",
  },
];

export default sampleBenefits;